import type { Finish } from "@tosize/shapes/src/types/finish";
import { EdgeBandComponent } from "@tosize/ui";
import { usePostDataContext } from "../../../../context/PostDataContext";
import { useEdgeBands } from "../../../../hooks/useEdgeBands";
import useFinishes from "../../../../hooks/useFinishes";

interface FinishOptionEdgeBandProps {
	finish: Finish;
	disabled: boolean;
}

export function FinishOptionEdgeBand({ finish, disabled }: FinishOptionEdgeBandProps) {
	const { finishes } = useFinishes();
	const { data: postData, selectedBand, setSelectedBand } = usePostDataContext();
	const { applyEdgeBandOnSides } = useEdgeBands();

	if (!postData.sku) {
		return null;
	}

	return (
		<EdgeBandComponent
			disabled={disabled}
			sku={postData.sku}
			suspense={finishes?.length === 1}
			onApplyCallback={(band) => applyEdgeBandOnSides(finish.availableOnSides, band)}
			selectedBand={selectedBand}
			setSelectedBand={setSelectedBand}
		/>
	);
}
